module.exports = __webpack_public_path__ + "static/media/p02.9e5da88a.png";